<div class="user-detail">
  <div class="header mt-3">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 0"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'USER_ADD_USER' | translate }}</h1>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="d-flex d-flex mt-4 pt-2 pb-3" *ngIf="!searchKeyPress">
      <h2 class="heading1 m-auto">{{ 'USER_NEW_USER' | translate }}</h2>
    </div>
  </div>
  <form
    [formGroup]="formGroup"
    tabindex="0"
    (keyup.enter)="submit()"
    #userDetails
    novalidate
  >
    <!-- form start -->
    <ng-container>
      <div class="form-group rounded-top form-container mt-4">
        <mat-form-field appearance="fill" class="w-100 mb-2 primary-input">
          <mat-label>{{ 'USER_FIRST_NAME' | translate }}</mat-label>
          <input
            matInput
            maxlength="100"
            [placeholder]="'USER_FIRST_NAME' | translate"
            formControlName="firstName"
          />
          <mat-error>
            <span *ngIf="formGroup?.controls?.firstName?.errors?.required">{{
              'YOU_MUST_ENTER_FIRST_NAME' | translate
            }}</span>
          </mat-error>

          <mat-error [ngSwitch]="true">
            <span
              *ngSwitchCase="
                formGroup?.controls?.firstName?.errors
                  ?.firstCharacterIsNumber &&
                !formGroup?.controls?.firstName?.errors?.whitespace &&
                !formGroup?.controls?.firstName?.errors?.required &&
                !formGroup?.controls?.firstName?.errors
                  ?.nameWithAllowedSpecialChars
              "
            >
              {{ 'FIRST_LETTER_MUST_BE_ALPHABETIC_CHARACTERS_ONLY' | translate }}
            </span>
          </mat-error>
          <mat-error>
            <span
              *ngIf="
                formGroup?.controls?.firstName?.errors
                  ?.nameWithAllowedSpecialChars &&
                !formGroup?.controls?.firstName?.errors?.whitespace
              "
            >
              {{ 'PLEASE_ENTER_A_VALID_NAME' | translate }}
            </span>
          </mat-error>

          <mat-error *ngIf="formGroup?.controls?.firstName?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>
          <mat-error *ngIf="formGroup?.controls?.firstName?.errors">
            <ng-container [ngSwitch]="true">
              <ng-container
                *ngSwitchCase="formGroup.controls.firstName.errors.maxlength"
              >
                {{
                  commonService.stringInterPolation(
                    ("MAXIMUM_OF_CHARACTERS" | translate),
                    "32"
                  )
                }}
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  !formGroup.controls.firstName.errors.required &&
                  !formGroup.controls.firstName.errors
                    .nameWithAllowedSpecialChars &&
                  !formGroup.controls.firstName.errors.whitespace &&
                  !formGroup?.controls?.firstName?.errors
                    ?.firstCharacterIsNumber
                "
              >
                {{
                  commonService.stringInterPolation(
                    ("MAXIMUM_OF_CHARACTERS" | translate),
                    "32"
                  )
                }}
              </ng-container>
              <ng-container *ngSwitchDefault> </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group rounded-top form-container">
        <mat-form-field appearance="fill" class="w-100 mb-2 primary-input">
          <mat-label>{{ 'USER_LAST_NAME' | translate }}</mat-label>
          <input
            matInput
            maxlength="100"
            [placeholder]="'USER_LAST_NAME' | translate"
            formControlName="lastName"
          />
          <mat-error>
            <span *ngIf="formGroup?.controls?.lastName?.errors?.required">{{
              'YOU_MUST_ENTER_LAST_NAME' | translate
            }}</span>
          </mat-error>

          <mat-error [ngSwitch]="true">
            <span
              *ngSwitchCase="
                formGroup?.controls?.lastName?.errors
                  ?.alphaNumWithAllowedSpecialCharacters &&
                !formGroup?.controls?.lastName?.errors?.whitespace &&
                !formGroup?.controls?.lastName?.errors?.required
              "
            >
              {{ 'LAST_NAME_ALPHA_NUMERIC' | translate }}
            </span>
            <span
              *ngSwitchCase="
                formGroup?.controls?.lastName?.errors?.firstCharacterIsNumber &&
                !formGroup?.controls?.lastName?.errors?.whitespace &&
                !formGroup?.controls?.lastName?.errors?.required &&
                !formGroup?.controls?.lastName?.errors
                  ?.nameWithAllowedSpecialChars
              "
            >
              {{ 'FIRST_LETTER_MUST_BE_ALPHABETIC_CHARACTERS_ONLY' | translate }}
            </span>
          </mat-error>

          <mat-error>
            <span
              *ngIf="
                formGroup?.controls?.lastName?.errors
                  ?.nameWithAllowedSpecialChars &&
                !formGroup?.controls?.lastName?.errors?.whitespace
              "
            >
              {{ 'PLEASE_ENTER_A_VALID_NAME' | translate }}
            </span>
          </mat-error>

          <mat-error *ngIf="formGroup?.controls?.lastName?.errors?.whitespace"
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>
          <mat-error *ngIf="formGroup?.controls?.lastName?.errors">
            <ng-container [ngSwitch]="true">
              <ng-container
                *ngSwitchCase="formGroup.controls.lastName.errors.maxlength"
              >
                {{
                  commonService.stringInterPolation(
                    ("MAXIMUM_OF_CHARACTERS" | translate),
                    "32"
                  )
                }}
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  !formGroup.controls.lastName.errors.required &&
                  !formGroup.controls.lastName.errors
                    .nameWithAllowedSpecialChars &&
                  !formGroup.controls.lastName.errors.whitespace &&
                  !formGroup?.controls?.lastName?.errors?.firstCharacterIsNumber
                "
              >
                {{
                  commonService.stringInterPolation(
                    ("MAXIMUM_OF_CHARACTERS" | translate),
                    "32"
                  )
                }}
              </ng-container>
              <ng-container *ngSwitchDefault> </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- <div class="mt-145 d-flex justify-content-center">
    <input
      type="file"
      #csvReader
      name="Upload CSV"
      (change)="uploadCsv($event)"
      accept=".csv"
      class="d-none"
    />
    <button
      type="button"
      [disabled]="deactivateCSV"
      (click)="csvReader.click()"
      class="import-csv-btn pointer-cursor pb-3"
    >
      {{ 'IMPORT_FROM_CSV' | translate }}
    </button>
      </div> -->
    </ng-container>
    <!-- form end -->

    <div class="row mt-180">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="formGroup?.invalid"
          type="button"
          (click)="submit()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
